import { App, URLOpenListenerEvent } from '@capacitor/app'
import { StatusBar, Style } from '@capacitor/status-bar'
import { FirebaseDynamicLinks } from '@pantrist/capacitor-firebase-dynamic-links'

export default defineNuxtPlugin(async (_nuxtApp) => {
  if (!useDetect().isApp) {
    return
  }
  StatusBar.setStyle({ style: Style.Light })
  StatusBar.setBackgroundColor({ color: '#ffffff' })

  const router = useRouter()
  App.addListener('backButton', () => {
    if (router) {
      router.go(-1)
    }
  })

  App.addListener('appUrlOpen', function (event: URLOpenListenerEvent) {
    console.log('on appUrlOpen', event)
    const slug = event.url.split('.io').pop()

    if (slug) {
      onNuxtReady(() => {
        console.log('replace to deep link', slug)
        router.replace(slug)
      })
    }
  })

  function listenToDeepLinkOpen() {
    FirebaseDynamicLinks.addListener('deepLinkOpen', (data) => {
      console.log('on deepLinkOpen', data)
    })
  }

  listenToDeepLinkOpen()

  usePushService().addListeners()
  await usePushService().registerNotifications()
})
